import type { FieldPath } from 'react-hook-form';

import {
  type FormItemGridSize,
  createNumberFieldElement,
} from '@modules/_shared/components/form/RaForm';
import { getRatingLabel } from '@modules/_shared/utils/formatting';
import type { Translate } from '@shared/hooks/locale';

export const getCompactGridProps = (
  compactMode?: boolean,
  minSize = 4,
): FormItemGridSize => {
  if (compactMode) {
    return { xs: Math.max(12, minSize), md: Math.max(6, minSize) }; // 2 columns in compact mode
  }
  return {
    xs: Math.max(6, minSize),
    sm: Math.max(6, minSize),
    md: Math.max(4, minSize),
  }; // 3 columns in normal mode
};

export const createDistanceFieldElement = <
  TFormData extends Record<string, any>,
>(
  name: FieldPath<TFormData>,
  label: string,
  gridProps: FormItemGridSize = { xs: 6, sm: 6, md: 4 },
) =>
  createNumberFieldElement(name, label, {
    suffix: 'm',
    gridProps,
  });

export const createSurfaceFieldElement = <
  TFormData extends Record<string, any>,
>(
  name: FieldPath<TFormData>,
  label: string,
  render?: (data: TFormData) => boolean,
  gridProps: FormItemGridSize = { xs: 6, sm: 6, md: 4 },
) =>
  createNumberFieldElement(name, label, {
    render,
    suffix: name === 'building_volume' ? 'm³' : 'm²',
    decimalNumbers: 1,
    gridProps,
  });

export const getRatingChoiceOptions = (t: Translate) => {
  const ratings: { value: number | null; label: string }[] = Array.from(
    { length: 5 },
    (_, i) => i + 1,
  ).map(i => ({ value: i, label: getRatingLabel(i, t) ?? i.toString() }));

  ratings.push({ value: null, label: t('Not set') });
  return ratings;
};
